import { render, staticRenderFns } from "./BTN.vue?vue&type=template&id=5fe299ad&scoped=true"
import script from "./BTN.vue?vue&type=script&lang=js"
export * from "./BTN.vue?vue&type=script&lang=js"
import style0 from "./BTN.vue?vue&type=style&index=0&id=5fe299ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe299ad",
  null
  
)

export default component.exports